import AddressColumn from '@/components/UIComponents/TableColumns/AddressColumn'
import BooleanColumn from '@/components/UIComponents/TableColumns/BooleanColumn'
import CommunityColumn from '@/components/UIComponents/TableColumns/CommunityColumn'
import CompanyColumn from '@/components/UIComponents/TableColumns/CompanyColumn'
import CsvColumn from '@/components/UIComponents/TableColumns/CsvColumn'
import DateColumn from '@/components/UIComponents/TableColumns/DateColumn'
import HtmlColumn from '@/components/UIComponents/TableColumns/HtmlColumn'
import InspectionResultsColumn from '@/components/UIComponents/TableColumns/InspectionResults'
import JobNameColumn from '@/components/UIComponents/TableColumns/JobNameColumn'
import LinkedTaskColumn from '@/components/UIComponents/TableColumns/LinkedTaskColumn'
import MoneyColumn from '@/components/UIComponents/TableColumns/MoneyColumn'
import PlanNameColumn from '@/components/UIComponents/TableColumns/PlanNameColumn'
import ProjectNameColumn from '@/components/UIComponents/TableColumns/ProjectNameColumn'
import PriceWithNotesColumn from '@/components/UIComponents/TableColumns/PriceWithNotesColumn'
import StringColumn from '@/components/UIComponents/TableColumns/StringColumn'
import TaskNameColumn from '@/components/UIComponents/TableColumns/TaskNameColumn'
import TaskColumn from '@/components/UIComponents/TableColumns/TaskColumn'
import TaskFieldsColumn from '@/components/UIComponents/TableColumns/TaskFields'
import TaskTemplateColumn from '@/components/UIComponents/TableColumns/TaskTemplateColumn'
import TravelChargeColumn from '@/components/UIComponents/TableColumns/TravelChargeColumn'

const tableColumns = {
  TASK_SEARCH: [
    {
      label: 'Task Name',
      prop: '_source',
      propBigData: '_source.name',
      sortProp: '_source.name',
      minWidth: 180,
      component: TaskColumn
    },
    {
      label: 'Plan Name',
      prop: '_source.job.planName',
      propBigData: '_source.job.planName.name',
      sortProp: '_source.job.planName.name',
      minWidth: 180,
      component: PlanNameColumn
    },
    {
      label: 'Linked Task',
      prop: '_source',
      propBigData: '_source.linkedTask.name',
      sortProp: '_source.linkedTask.name',
      minWidth: 180,
      component: LinkedTaskColumn
    },
    {
      label: 'Assignee',
      prop: '_source.assignee',
      propBigData: '_source.assignee',
      sortProp: '_source.assignee',
      minWidth: 140,
      component: StringColumn
    },
    {
      label: 'Owner',
      prop: '_source.owner',
      propBigData: '_source.owner',
      sortProp: '_source.owner',
      minWidth: 140,
      component: StringColumn
    },
    {
      label: 'Due Date',
      prop: '_source.dueDate',
      propBigData: '_source.dueDate',
      sortProp: '_source.dueDate',
      minWidth: 150,
      component: DateColumn
    },
    {
      label: 'Completion Date',
      prop: '_source.completionDate',
      propBigData: '_source.completionDate',
      sortProp: '_source.completionDate',
      minWidth: 195,
      component: DateColumn
    },
    {
      label: 'Status',
      prop: '_source.status',
      propBigData: '_source.status',
      sortProp: '_source.status',
      minWidth: 115,
      component: StringColumn
    },
    {
      label: 'Task Priority',
      prop: '_source.priorityLabel',
      propBigData: '_source.priorityLabel',
      sortProp: '_source.priority',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Task Template',
      prop: '_source.taskTemplate',
      propBigData: '_source.taskTemplate.name',
      sortProp: '_source.taskTemplate.name',
      minWidth: 175,
      component: TaskTemplateColumn
    },
    {
      label: 'Project Name',
      prop: '_source.project',
      propBigData: '_source.project.name',
      sortProp: '_source.project.name',
      minWidth: 200,
      component: ProjectNameColumn
    },
    {
      label: 'Project Type',
      prop: '_source.project.projectType',
      propBigData: '_source.project.projectType',
      sortProp: '_source.project.projectType',
      minWidth: 155,
      component: StringColumn
    },
    {
      label: 'Task Fields',
      prop: '_source',
      propBigData: false,
      sortProp: '_source.fieldValues',
      minWidth: 300,
      component: TaskFieldsColumn
    },
    {
      label: 'P.O. Number',
      prop: '_source.fieldValues.poNumber',
      propBigData: '_source.fieldValues.poNumber',
      sortProp: '_source.fieldValues.poNumber',
      minWidth: 135,
      component: StringColumn
    },
    {
      label: 'Price',
      prop: '_source.fieldValues.price',
      propBigData: '_source.fieldValues.price',
      sortProp: '_source.fieldValues.price',
      minWidth: 105,
      component: MoneyColumn
    },
    {
      label: 'Travel Charge',
      prop: '_source.fieldValues.travelCharge',
      propBigData: '_source.fieldValues.travelCharge',
      sortProp: '_source.fieldValues.travelCharge',
      minWidth: 145,
      component: MoneyColumn
    },
    {
      label: 'Hours Worked',
      prop: '_source.fieldValues.hoursWorked',
      propBigData: '_source.fieldValues.hoursWorked',
      sortProp: '_source.fieldValues.hoursWorked',
      minWidth: 145,
      component: StringColumn
    },
    {
      label: 'Address',
      prop: '_source.project.address',
      propBigData: false,
      sortProp: '_source.project.address',
      minWidth: 275,
      component: AddressColumn
    },
    {
      label: 'Building Number',
      prop: '_source.project.address.buildingNumber',
      propBigData: '_source.project.address.buildingNumber',
      sortProp: '_source.project.address.buildingNumber',
      minWidth: 180,
      component: StringColumn
    },
    {
      label: 'Suite Number',
      prop: '_source.project.address.suiteNumber',
      propBigData: '_source.project.address.suiteNumber',
      sortProp: '_source.project.address.suiteNumber',
      minWidth: 155,
      component: StringColumn
    },
    {
      label: 'Street Number',
      prop: '_source.project.address.streetNumber',
      propBigData: '_source.project.address.streetNumber',
      sortProp: '_source.project.address.streetNumber',
      minWidth: 165,
      component: StringColumn
    },
    {
      label: 'Floor Number',
      prop: '_source.project.address.floorNumber',
      propBigData: '_source.project.address.floorNumber',
      sortProp: '_source.project.address.floorNumber',
      minWidth: 155,
      component: StringColumn
    },
    {
      label: 'Street Name',
      prop: '_source.project.address.streetName',
      propBigData: '_source.project.address.streetName',
      sortProp: '_source.project.address.streetName',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'City',
      prop: '_source.project.address.city',
      propBigData: '_source.project.address.city',
      sortProp: '_source.project.address.city',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Job Name',
      prop: '_source.job',
      propBigData: '_source.job.name',
      sortProp: '_source.job.name',
      minWidth: 150,
      component: JobNameColumn
    },
    {
      label: 'Client',
      prop: '_source.job.client',
      propBigData: '_source.job.client.name',
      sortProp: '_source.job.client.name',
      minWidth: 175,
      component: CompanyColumn
    },
    {
      label: 'Client Types',
      prop: '_source.job.client.types',
      propBigData: '_source.job.client.types',
      sortProp: '_source.job.client.types',
      minWidth: 145,
      component: CsvColumn
    },
    {
      label: 'Builder',
      prop: '_source.job.builder',
      propBigData: '_source.job.builder.name',
      sortProp: '_source.job.builder.name',
      minWidth: 175,
      component: CompanyColumn
    },
    {
      label: 'Job Priority',
      prop: '_source.job.priorityLabel',
      propBigData: '_source.job.priorityLabel',
      sortProp: '_source.job.priority',
      minWidth: 185,
      component: StringColumn
    },
    {
      label: 'Community',
      prop: '_source.job.community',
      propBigData: '_source.job.community.name',
      sortProp: '_source.job.community.name',
      minWidth: 185,
      component: CommunityColumn
    },
    {
      label: 'Notes',
      prop: '_source.notes',
      propBigData: '_source.notes',
      sortProp: '_source.notes',
      minWidth: 185,
      component: HtmlColumn
    },
    {
      label: 'Job Status',
      prop: '_source.job.status',
      propBigData: '_source.job.status',
      sortProp: '_source.job.status',
      minWidth: 185,
      component: StringColumn
    },
    {
      label: 'Permit Number',
      prop: '_source.job.permitNumber',
      propBigData: '_source.job.permitNumber',
      sortProp: '_source.job.permitNumber',
      minWidth: 170,
      component: StringColumn
    }
  ],
  MY_TASKS: [
    {
      label: 'Task Name',
      sortProp: 'name',
      minWidth: 180,
      component: TaskColumn
    },
    {
      label: 'Plan Name',
      prop: 'job.planName',
      sortProp: 'job.planName.name',
      minWidth: 180,
      component: PlanNameColumn
    },
    {
      label: 'Owner',
      prop: 'owner',
      sortProp: 'owner',
      minWidth: 140,
      component: StringColumn
    },
    {
      label: 'P.O. Number',
      prop: 'fieldValues.poNumber',
      sortProp: 'fieldValues.poNumber',
      minWidth: 135,
      component: StringColumn
    },
    {
      label: 'Task Fields',
      sortProp: 'fieldValues',
      minWidth: 300,
      component: TaskFieldsColumn
    },
    {
      label: 'Due Date',
      prop: 'dueDate',
      sortProp: 'dueDate',
      minWidth: 150,
      component: DateColumn
    },
    {
      label: 'Completion Date',
      prop: 'completionDate',
      sortProp: 'completionDate',
      minWidth: 195,
      component: DateColumn
    },
    {
      label: 'Status',
      prop: 'status',
      sortProp: 'status',
      minWidth: 115,
      component: StringColumn
    },
    {
      label: 'Task Priority',
      prop: 'priorityLabel',
      sortProp: 'priority',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Task Template',
      prop: 'taskTemplate',
      sortProp: 'taskTemplate.name',
      minWidth: 175,
      component: TaskTemplateColumn
    },
    {
      label: 'Project Name',
      prop: 'project',
      sortProp: 'project.name',
      minWidth: 200,
      component: ProjectNameColumn
    },
    {
      label: 'Project Type',
      prop: 'project.projectType',
      sortProp: 'project.projectType',
      minWidth: 155,
      component: StringColumn
    },
    {
      label: 'Price',
      prop: 'fieldValues.price',
      sortProp: 'fieldValues.price',
      minWidth: 105,
      component: MoneyColumn
    },
    {
      label: 'Travel Charge',
      prop: 'fieldValues.travelCharge',
      sortProp: 'fieldValues.travelCharge',
      minWidth: 145,
      component: MoneyColumn
    },
    {
      label: 'Hours Worked',
      prop: 'fieldValues.hoursWorked',
      sortProp: 'fieldValues.hoursWorked',
      minWidth: 145,
      component: StringColumn
    },
    {
      label: 'Address',
      prop: 'project.address',
      sortProp: 'project.address',
      minWidth: 275,
      component: AddressColumn
    },
    {
      label: 'Building Number',
      prop: 'project.address.buildingNumber',
      sortProp: 'project.address.buildingNumber',
      minWidth: 180,
      component: StringColumn
    },
    {
      label: 'Suite Number',
      prop: 'project.address.suiteNumber',
      sortProp: 'project.address.suiteNumber',
      minWidth: 155,
      component: StringColumn
    },
    {
      label: 'Street Number',
      prop: 'project.address.streetNumber',
      sortProp: 'project.address.streetNumber',
      minWidth: 165,
      component: StringColumn
    },
    {
      label: 'Floor Number',
      prop: 'project.address.floorNumber',
      sortProp: 'project.address.floorNumber',
      minWidth: 155,
      component: StringColumn
    },
    {
      label: 'Street Name',
      prop: 'project.address.streetName',
      sortProp: 'project.address.streetName',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'City',
      prop: 'project.address.city',
      sortProp: 'project.address.city',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Job Name',
      prop: 'job.name',
      sortProp: 'job.name',
      minWidth: 150,
      component: StringColumn
    },
    {
      label: 'Client',
      prop: 'job.client',
      sortProp: 'job.client.name',
      minWidth: 175,
      component: CompanyColumn
    },
    {
      label: 'Client Types',
      prop: 'job.client.types',
      sortProp: 'job.client.types',
      minWidth: 145,
      component: CsvColumn
    },
    {
      label: 'Builder',
      prop: 'job.builder',
      sortProp: 'job.builder.name',
      minWidth: 175,
      component: CompanyColumn
    },
    {
      label: 'Job Priority',
      prop: 'job.priorityLabel',
      sortProp: 'job.priority',
      minWidth: 185,
      component: StringColumn
    },
    {
      label: 'Community',
      prop: 'job.community',
      sortProp: 'job.community.name',
      minWidth: 185,
      component: CommunityColumn
    },
    {
      label: 'Notes',
      prop: 'notes',
      sortProp: 'notes',
      minWidth: 185,
      component: HtmlColumn
    }
  ],
  CREATE_INVOICES: [
    {
      label: 'Price',
      sortProp: 'fieldValues.price',
      propBigData: 'fieldValues.price',
      minWidth: 130,
      component: PriceWithNotesColumn
    },
    {
      label: 'Travel Charge',
      sortProp: 'fieldValues.travelCharge',
      propBigData: 'fieldValues.travelCharge',
      minWidth: 160,
      component: TravelChargeColumn
    },
    {
      label: 'P.O. Number',
      prop: 'fieldValues.poNumber',
      sortProp: 'fieldValues.poNumber',
      propBigData: 'fieldValues.poNumber',
      minWidth: 135,
      component: StringColumn
    },
    {
      label: 'QB Item Code',
      prop: 'fieldValues.qbItemCode',
      sortProp: 'fieldValues.qbItemCode',
      propBigData: 'fieldValues.qbItemCode',
      minWidth: 145,
      component: StringColumn
    },
    {
      label: 'Task Fields',
      sortProp: 'fieldValues',
      propBigData: false,
      minWidth: 300,
      component: TaskFieldsColumn
    },
    {
      label: 'Linked Task',
      sortProp: 'linkedTask.name',
      propBigData: 'linkedTask.name',
      minWidth: 180,
      component: LinkedTaskColumn
    },
    {
      label: 'Inspection Results',
      sortProp: 'fieldValues.inspectionResult',
      propBigData: 'fieldValues.inspectionResult',
      minWidth: 230,
      component: InspectionResultsColumn
    },
    {
      label: 'Task Priority',
      prop: 'priorityLabel',
      propBigData: 'priorityLabel',
      sortProp: 'priority',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Project Name',
      prop: 'project',
      propBigData: 'project.name',
      sortProp: 'project.name',
      minWidth: 200,
      component: ProjectNameColumn
    },
    {
      label: 'Project Type',
      prop: 'project.projectType',
      sortProp: 'project.projectType',
      propBigData: 'project.projectType',
      minWidth: 155,
      component: StringColumn
    },
    {
      label: 'Building Number',
      prop: 'project.address.buildingNumber',
      sortProp: 'project.address.buildingNumber',
      propBigData: 'project.address.buildingNumber',
      minWidth: 180,
      component: StringColumn
    },
    {
      label: 'Suite Number',
      prop: 'project.address.suiteNumber',
      sortProp: 'project.address.suiteNumber',
      propBigData: 'project.address.suiteNumber',
      minWidth: 155,
      component: StringColumn
    },
    {
      label: 'Street Number',
      prop: 'project.address.streetNumber',
      sortProp: 'project.address.streetNumber',
      propBigData: 'project.address.streetNumber',
      minWidth: 165,
      component: StringColumn
    },
    {
      label: 'Floor Number',
      prop: 'project.address.floorNumber',
      sortProp: 'project.address.floorNumber',
      propBigData: 'project.address.floorNumber',
      minWidth: 160,
      component: StringColumn
    },
    {
      label: 'Street Name',
      prop: 'project.address.streetName',
      sortProp: 'project.address.streetName',
      propBigData: 'project.address.streetName',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'City',
      prop: 'project.address.city',
      sortProp: 'project.address.city',
      propBigData: 'project.address.city',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Job Name',
      prop: 'job',
      sortProp: 'job.name',
      propBigData: 'job.name',
      minWidth: 150,
      component: JobNameColumn
    },
    {
      label: 'Client',
      prop: 'job.client',
      sortProp: 'job.client.name',
      propBigData: 'job.client.name',
      minWidth: 175,
      component: CompanyColumn
    },
    {
      label: 'Builder',
      prop: 'job.builder',
      sortProp: 'job.builder.name',
      propBigData: 'job.builder.name',
      minWidth: 175,
      component: CompanyColumn
    },
    {
      label: 'Job Priority',
      prop: 'job.priorityLabel',
      sortProp: 'job.priority',
      propBigData: 'job.priorityLabel',
      minWidth: 185,
      component: StringColumn
    },
    {
      label: 'Community',
      prop: 'job.community',
      sortProp: 'job.community.name',
      propBigData: 'job.community.name',
      minWidth: 185,
      component: CommunityColumn
    }
  ],
  PROJECT_DEPARTMENT: [
    {
      label: 'Target Completion Date',
      prop: 'targetCompletionDate',
      sortProp: 'targetCompletionDate',
      minWidth: 245,
      component: DateColumn
    },
    {
      label: 'Date Received',
      prop: 'dateReceived',
      sortProp: 'dateReceived',
      minWidth: 165,
      component: DateColumn
    },
    {
      label: 'Actual Completion Date',
      prop: 'actualCompletionDate',
      sortProp: 'actualCompletionDate',
      minWidth: 245,
      component: DateColumn
    },
    {
      label: 'Status',
      prop: 'status',
      sortProp: 'status',
      minWidth: 115,
      component: StringColumn
    },
    {
      label: 'Job Name',
      sortProp: 'name',
      minWidth: 195,
      component: JobNameColumn
    },
    {
      label: 'Client',
      prop: 'client',
      sortProp: 'client.name',
      minWidth: 175,
      component: CompanyColumn
    },
    {
      label: 'Builder',
      prop: 'builder',
      sortProp: 'builder.name',
      minWidth: 175,
      component: CompanyColumn
    },
    {
      label: 'Client Contact',
      prop: 'clientContact.name',
      sortProp: 'clientContact.name',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Builder Contact',
      prop: 'builderContact.name',
      sortProp: 'builderContact.name',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Priority',
      prop: 'priorityLabel',
      sortProp: 'priority',
      minWidth: 150,
      component: StringColumn
    },
    {
      label: 'Plan Name',
      prop: 'planName',
      sortProp: 'planName.name',
      minWidth: 150,
      component: PlanNameColumn
    },
    {
      label: 'Community',
      prop: 'community',
      sortProp: 'community.name',
      minWidth: 185,
      component: CommunityColumn
    },
    {
      label: 'Coordinator',
      prop: 'coordinatorName',
      sortProp: 'coordinatorName',
      minWidth: 150,
      component: StringColumn
    }
  ],
  JOB_SEARCH: [
    {
      label: 'Actual Completion Date',
      prop: '_source.actualCompletionDate',
      sortProp: '_source.actualCompletionDate',
      minWidth: 245,
      component: DateColumn
    },
    {
      label: 'Builder',
      prop: '_source.builder',
      sortProp: '_source.builder.name',
      minWidth: 150,
      component: CompanyColumn
    },
    {
      label: 'Builder Contact',
      prop: '_source.builderContact.name',
      sortProp: '_source.builderContact.name',
      minWidth: 200,
      component: StringColumn
    },
    {
      label: 'Client',
      prop: '_source.client',
      sortProp: '_source.client.name',
      minWidth: 150,
      component: CompanyColumn
    },
    {
      label: 'Client Contact',
      prop: '_source.clientContact.name',
      sortProp: '_source.clientContact.name',
      minWidth: 200,
      component: StringColumn
    },
    {
      label: 'Community',
      prop: '_source.community',
      sortProp: '_source.community.name',
      minWidth: 200,
      component: CommunityColumn
    },
    {
      label: 'Coordinator',
      prop: '_source.coordinator',
      sortProp: '_source.coordinator',
      minWidth: 200,
      component: StringColumn
    },
    {
      label: 'Date Received',
      prop: '_source.dateReceived',
      sortProp: '_source.dateReceived',
      minWidth: 200,
      component: DateColumn
    },
    {
      label: 'Elevation',
      prop: '_source.elevation',
      sortProp: '_source.elevation',
      minWidth: 150,
      component: StringColumn
    },
    {
      label: 'Job Name',
      prop: '_source',
      sortProp: '_source.name',
      minWidth: 200,
      component: JobNameColumn
    },
    {
      label: 'Job Number',
      prop: '_source.number',
      sortProp: '_source.number',
      minWidth: 200,
      component: StringColumn
    },
    {
      label: 'Plan Name',
      prop: '_source.planName',
      sortProp: '_source.planName.name',
      minWidth: 150,
      component: PlanNameColumn
    },
    {
      label: 'Priority',
      prop: '_source.priorityLabel',
      sortProp: '_source.priority',
      minWidth: 150,
      component: StringColumn
    },
    {
      label: 'Project Name',
      prop: '_source.project',
      sortProp: '_source.project.name',
      minWidth: 200,
      component: ProjectNameColumn
    },
    {
      label: 'Project Type',
      prop: '_source.project.projectType',
      sortProp: '_source.project.projectType',
      minWidth: 150,
      component: StringColumn
    },
    {
      label: 'Status',
      prop: '_source.status',
      sortProp: '_source.status',
      minWidth: 150,
      component: StringColumn
    },
    {
      label: 'Target Completion Date',
      prop: '_source.targetCompletionDate',
      sortProp: '_source.targetCompletionDate',
      minWidth: 245,
      component: DateColumn
    },
    {
      label: 'Permit Number',
      prop: '_source.permitNumber',
      sortProp: '_source.permitNumber',
      minWidth: 170,
      component: StringColumn
    }
  ],
  PRICE_RULE_SEARCH: [
    {
      label: 'Price',
      prop: '_source.price',
      sortProp: '_source.price',
      minWidth: 110,
      component: MoneyColumn
    },
    {
      label: 'Hourly',
      prop: '_source.hourly',
      sortProp: '_source.hourly',
      minWidth: 100,
      component: BooleanColumn
    },
    {
      label: 'Client',
      prop: '_source.client',
      sortProp: '_source.client.name',
      minWidth: 175,
      component: CompanyColumn
    },
    {
      label: 'Job Name',
      prop: '_source.jobName',
      sortProp: '_source.jobName',
      minWidth: 160,
      component: StringColumn
    },
    {
      label: 'Hourly Rate',
      prop: '_source.hourlyRate',
      sortProp: '_source.hourlyRate',
      minWidth: 140,
      component: MoneyColumn
    },
    {
      label: 'Task Name',
      prop: '_source.taskName',
      sortProp: '_source.taskName.name',
      minWidth: 180,
      component: TaskNameColumn
    },
    {
      label: 'Project Type',
      prop: '_source.projectType',
      sortProp: '_source.projectType',
      minWidth: 150,
      component: StringColumn
    },
    {
      label: 'Client Default',
      prop: '_source.clientDefault',
      sortProp: '_source.clientDefault',
      minWidth: 165,
      component: BooleanColumn
    },
    {
      label: 'Project Default',
      prop: '_source.projectDefault',
      sortProp: '_source.projectDefault',
      minWidth: 175,
      component: BooleanColumn
    },
    {
      label: 'Location',
      prop: '_source.location',
      sortProp: '_source.location',
      minWidth: 175,
      component: BooleanColumn
    },
    {
      label: 'Repeated Task',
      prop: '_source.repeatedTask',
      sortProp: '_source.repeatedTask',
      minWidth: 150,
      component: BooleanColumn
    },
    {
      label: 'Travel Charge',
      prop: '_source.travelCharge',
      sortProp: '_source.travelCharge',
      minWidth: 160,
      component: BooleanColumn
    },
    {
      label: 'Expiry Date',
      prop: '_source.expiry',
      sortProp: '_source.expiry',
      minWidth: 140,
      component: DateColumn
    },
    {
      label: 'City',
      prop: '_source.city',
      sortProp: '_source.city',
      minWidth: 160,
      component: StringColumn
    },
    {
      label: 'Project Name',
      prop: '_source.projectName',
      sortProp: '_source.projectName',
      minWidth: 160,
      component: StringColumn // Need complete project to use ProjectNameColumn
    },
    {
      label: 'Building Number',
      prop: '_source.buildingNumber',
      sortProp: '_source.buildingNumber',
      minWidth: 180,
      component: StringColumn
    },
    {
      label: 'Suite Number',
      prop: '_source.suiteNumber',
      sortProp: '_source.suiteNumber',
      minWidth: 150,
      component: StringColumn
    },
    {
      label: 'Street Number',
      prop: '_source.streetNumber',
      sortProp: '_source.streetNumber',
      minWidth: 165,
      component: StringColumn
    },
    {
      label: 'Floor Number',
      prop: '_source.floorNumber',
      sortProp: '_source.floorNumber',
      minWidth: 155,
      component: StringColumn
    },
    {
      label: 'Street Name',
      prop: '_source.streetName',
      sortProp: '_source.streetName',
      minWidth: 160,
      component: StringColumn
    },
    {
      label: 'Jurisdiction',
      prop: '_source.jurisdiction',
      sortProp: '_source.jurisdiction',
      minWidth: 150,
      component: StringColumn
    },
    {
      label: 'Legal Subdivision',
      prop: '_source.legalSubdivision',
      sortProp: '_source.legalSubdivision',
      minWidth: 185,
      component: StringColumn
    },
    {
      label: 'County',
      prop: '_source.county',
      sortProp: '_source.county',
      minWidth: 160,
      component: StringColumn
    },
    {
      label: 'Builder',
      prop: '_source.builder',
      sortProp: '_source.builder.name',
      minWidth: 175,
      component: CompanyColumn
    },
    {
      label: 'Department',
      prop: '_source.department',
      sortProp: '_source.department',
      minWidth: 160,
      component: StringColumn
    },
    {
      label: 'Community',
      prop: '_source.community',
      sortProp: '_source.community.name',
      minWidth: 160,
      component: CommunityColumn
    }
  ],
  IDA_ARCHIVE: [
    {
      label: 'Client Name',
      prop: '_source.clientName',
      sortProp: '_source.clientName',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Builder Name',
      prop: '_source.builderName',
      sortProp: '_source.builderName',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Subdivision Name',
      prop: '_source.subdivisionName',
      sortProp: '_source.subdivisionName',
      minWidth: 190,
      component: StringColumn
    },
    {
      label: 'Street Number',
      prop: '_source.streetNumber',
      sortProp: '_source.streetNumber',
      minWidth: 170,
      component: StringColumn
    },
    {
      label: 'Street Name',
      prop: '_source.streetName',
      sortProp: '_source.streetName',
      minWidth: 160,
      component: StringColumn
    },
    {
      label: 'City',
      prop: '_source.city',
      sortProp: '_source.city',
      minWidth: 165,
      component: StringColumn
    },
    {
      label: 'State',
      prop: '_source.state',
      sortProp: '_source.state',
      minWidth: 120,
      component: StringColumn
    },
    {
      label: 'Inspection Type',
      prop: '_source.inspectionType',
      sortProp: '_source.inspectionType',
      minWidth: 175,
      component: StringColumn
    },
    {
      label: 'Scheduled By',
      prop: '_source.scheduledBy',
      sortProp: '_source.scheduledBy',
      minWidth: 160,
      component: StringColumn
    },
    {
      label: 'Date Scheduled',
      prop: '_source.dateScheduled',
      sortProp: '_source.dateScheduled',
      minWidth: 185,
      component: DateColumn
    },
    {
      label: 'Inspected By',
      prop: '_source.inspectedBy',
      sortProp: '_source.inspectedBy',
      minWidth: 150,
      component: StringColumn
    },
    {
      label: 'Inspection Result',
      prop: '_source.inspectionResult',
      sortProp: '_source.inspectionResult',
      minWidth: 195,
      component: StringColumn
    },
    {
      label: 'ID',
      prop: '_source.idaId',
      sortProp: '_source.idaId',
      minWidth: 150,
      component: StringColumn
    }
  ]
}

export default tableColumns
